import type { CoreApiClient } from "../client";
import { createAuthMutations } from "../mutations/auth.mutations";
import { createAuthQueries } from "../queries/auth.queries";

export const createAuthRepository = (api: CoreApiClient) => ({
  ...createAuthQueries(api),
  ...createAuthMutations(api),
});
